import * as moment from 'moment'
import React, { useEffect, useState } from 'react'
import {
    Button,
    Card,
    Grid,
    Dialog,
    DialogTitle,
    Input,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
} from '@material-ui/core'
import {
    NavigateBefore as NavigateBeforeIcon,
    NavigateNext as NavigateNextIcon,
    Save as SaveIcon,
    Today as TodayIcon,
} from '@material-ui/icons'

import BigCalendar from 'react-big-calendar';
import { bindActionCreators } from 'redux'
import ReduxGlobal from '../../../../../../store/actionreducers/globalView'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
const localizer = BigCalendar.momentLocalizer(moment);

//Do not edit or rearrange the list as I am using the fixed index
export const TimePeriods = [
    { id: 7, key: 'morning', name: '早診', label: '09:00~12:00' },
    { id: 8, key: 'noon', name: '午診', label: '14:00~17:00' },
    { id: 9, key: 'night', name: '晚診', label: '19:00~21:00' },
    { id: 57, key: '0-1', name: '0-1', label: '00:00~01:00' },
    { id: 58, key: '1-2', name: '1-2', label: '01:00~02:00' },
    { id: 59, key: '2-3', name: '2-3', label: '02:00~03:00' },
    { id: 60, key: '3-4', name: '3-4', label: '03:00~04:00' },
    { id: 61, key: '4-5', name: '4-5', label: '04:00~05:00' },
    { id: 62, key: '5-6', name: '5-6', label: '05:00~06:00' },
    { id: 63, key: '6-7', name: '6-7', label: '06:00~07:00' },
    { id: 64, key: '7-8', name: '7-8', label: '07:00~08:00' },
    { id: 10, key: '8-9', name: '8-9', label: '08:00~09:00' },
    { id: 11, key: '9-10', name: '9-10', label: '09:00~10:00' },
    { id: 12, key: '10-11', name: '10-11', label: '10:00~11:00' },
    { id: 13, key: '11-12', name: '11-12', label: '11:00~12:00' },
    { id: 14, key: '12-13', name: '12-13', label: '12:00~13:00' },
    { id: 15, key: '13-14', name: '13-14', label: '13:00~14:00' },
    { id: 16, key: '14-15', name: '14-15', label: '14:00~15:00' },
    { id: 17, key: '15-16', name: '15-16', label: '15:00~16:00' },
    { id: 18, key: '16-17', name: '16-17', label: '16:00~17:00' },
    { id: 19, key: '17-18', name: '17-18', label: '17:00~18:00' },
    { id: 20, key: '18-19', name: '18-19', label: '18:00~19:00' },
    { id: 21, key: '19-20', name: '19-20', label: '19:00~20:00' },
    { id: 22, key: '20-21', name: '20-21', label: '20:00~21:00' },
    { id: 23, key: '21-22', name: '21-22', label: '21:00~22:00' },
    { id: 24, key: '22-23', name: '22-23', label: '22:00~23:00' },
    { id: 65, key: '23-24', name: '23-24', label: '23:00~24:00' },
]

const findTimerPeriodIndexById = ({timePeriodId}) => {
    const index = TimePeriods.findIndex(tp => tp.id === timePeriodId)
    return index
}

export const WeekDays = [
    { id: 1, key: 'Mon', label: '周一' },
    { id: 2, key: 'Tue', label: '周二' },
    { id: 3, key: 'Wed', label: '周三' },
    { id: 4, key: 'Thu', label: '周四' },
    { id: 5, key: 'Fri', label: '周五' },
    { id: 6, key: 'Sat', label: '周六' },
    { id: 7, key: 'Sun', label: '周日' },
]
const weekDayMap = {
    Sun: '日',
    Mon: '一',
    Tue: '二',
    Wed: '三',
    Thu: '四',
    Fri: '五',
    Sat: '六',
};

const monthCustomHeader = ({label}) => (
    <div>{weekDayMap[label]}</div>
);

// The Tool bar of the agenda calendar
const agendaToolbar = (toolbar) => {
    // Going to the previous month
    const goToBack = () => {
        toolbar.date.setMonth(toolbar.date.getMonth() - 1);
        toolbar.onNavigate('prev');
    };

    // Going to the next month
    const goToNext = () => {
        toolbar.date.setMonth(toolbar.date.getMonth() + 1);
        toolbar.onNavigate('next');
    };

    const goToCurrent = () => {
        const now = new Date();
        toolbar.date.setMonth(now.getMonth());
        toolbar.date.setYear(now.getFullYear());
        toolbar.onNavigate('current');
    };

    // The title of the agenda bar
    const agendaTitle = () => {
        const date = moment(toolbar.date);
        return (
            <Grid container className='items-center' style={{fontSize: 32}}>
                <Grid item>{date.format('YYYY年')}</Grid>
                <Grid item>{date.format('MM月')}</Grid>
                <Button onClick={goToCurrent} >
                    <TodayIcon className='pl-4' style={{fontSize: 40, cursor: 'pointer'}} />
                </Button>
            </Grid>
        );
    };

    return (
        <Grid container className='justify-between items-center py-12'>
            {/*The Go Back Button*/}
            <Grid item className='pl-12'>
                <Button onClick={goToBack}>
                    <NavigateBeforeIcon style={{fontSize: 40, cursor: 'pointer'}} />
                </Button>
            </Grid>
            {/*Title: The current year and month*/}
            <Grid item>{agendaTitle()}</Grid>
            {/*The Go Next Button*/}
            <Grid item className='pr-12'>
                <Button onClick={goToNext}>
                    <NavigateNextIcon style={{fontSize: 40, cursor: 'pointer'}} />
                </Button>
            </Grid>
        </Grid>
    );
}

const AgendaPrice = ({ price: { min, max } }) => {
    return min === max
        ? `US$${(min * 0.01).toFixed(2)}`
        : `US$${(min * 0.01).toFixed(2)}~US$${(max * 0.01).toFixed(2)}`
}


const EditTimePeriodDialog = ({
    selectedDate,
    handleClose,
    openModal,
    timePeriods,
    setTimePeriods,
    onSaveButtonClick,
    workEvents,
}) => {
    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={openModal} maxWidth='lg'>
            {/* Dialog Header */}
            <DialogTitle>
                <Grid container className="justify-between items-center">
                    <Grid item>
                        {moment(selectedDate).format('YYYY 年 MM 月 DD 日')}
                    </Grid>
                    <Grid item>
                        {/*The Save Button*/}
                        <Button onClick={() => {
                            const dateString = moment(selectedDate).format('YYYY-MM-DD')
                            // Get all time periods on the edit screen of the given day which check box is checked
                            // Example: all checked periods in 2021-05-20
                            const savingTimePeriods = timePeriods
                                .filter(tp => tp.checked)
                                .map(tp => {
                                    return {
                                        date: dateString,
                                        timePeriodId: tp.id,
                                        markedPriceCent: tp.markedPriceDollar * 100,
                                        workTime: tp.workTime,
                                        breakTime: tp.breakTime,
                                        currencyId: 2,
                                    }
                                })
                            onSaveButtonClick(dateString, savingTimePeriods)
                            handleClose()
                        }}>
                            <SaveIcon />
                        </Button>
                    </Grid>
                </Grid>
            </DialogTitle>
            {/* Dialog Body: 時段編輯 */}
            <div className="pl-40 pr-40 pb-40">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className="flex-no-wrap px-4 text-center">時段</TableCell>
                            <TableCell className="flex-no-wrap px-4 text-center">排班</TableCell>
                            <TableCell className="flex-no-wrap px-4 text-center">價格 (US$)</TableCell>
                            <TableCell className="flex-no-wrap px-4 text-center">看診時間(分鐘)</TableCell>
                            <TableCell className="flex-no-wrap px-4 text-center">診間休息(分鐘)</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                        timePeriods && timePeriods.map((tp, index) => (
                            tp.id > 9 &&
                                <TableRow key={index}>
                                    <TableCell className="flex-no-wrap px-4 text-center">{tp.label}</TableCell>
                                    <TableCell className="flex-no-wrap px-4 text-center">
                                        <Switch color="secondary" checked={tp.checked}
                                                onChange={() => {
                                                    const updatingTimePeriods = timePeriods.slice()
                                                    updatingTimePeriods[index].checked = !tp.checked
                                                    setTimePeriods(updatingTimePeriods)
                                                }}/>
                                    </TableCell>
                                    {tp.checked && ([
                                        <TableCell key={'price' + index} className="flex-no-wrap px-4 text-center">
                                            <Input type='number' style={{width: 50, textAlign: 'right'}}
                                                   value={tp.markedPriceDollar}
                                                   onChange={e => {
                                                       const updatingTimePeriods = timePeriods.slice()
                                                       updatingTimePeriods[index].markedPriceDollar = e.target.value
                                                       setTimePeriods(updatingTimePeriods)
                                                   }}/>
                                        </TableCell>,
                                        <TableCell key={'workTime' + index}
                                                   className="flex-no-wrap px-4 text-center">
                                            <Input type='number' style={{width: 50, textAlign: 'right'}}
                                                   value={tp.workTime}
                                                   onChange={e => {
                                                       const updatingTimePeriods = timePeriods.slice()
                                                       updatingTimePeriods[index].workTime = e.target.value
                                                       setTimePeriods(updatingTimePeriods)
                                                   }}/>
                                        </TableCell>,
                                        <TableCell key={'breakTime' + index}
                                                   className="flex-no-wrap px-4 text-center">
                                            <Input type='number' style={{width: 50, textAlign: 'right'}}
                                                   value={tp.breakTime}
                                                   onChange={e => {
                                                       const updatingTimePeriods = timePeriods.slice()
                                                       updatingTimePeriods[index].breakTime = e.target.value
                                                       setTimePeriods(updatingTimePeriods)
                                                   }}/>
                                        </TableCell>])
                                    }
                                </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </Dialog>
    )
}

const AgendaTable = props => {
    const {
        mptId,
        onDateUpdate,
        onSaveButtonClick,
        openDataDialog,
        workEvents,
    } = props

    const [openModal, setOpenModal] = useState(false)
    const [selectedDate, setSelectedDate] = useState(null)
    const [timePeriods, setTimePeriods] = useState([])
    const [defaultPrice, setDefaultPrice] = useState(0)
    const [defaultWorkTime, setDefaultWorkTime] = useState(10)
    const [defaultBreakTime, setDefaultBreakTime] = useState(0)

    const handleClose = () => {
        setOpenModal(false)
    }

    useEffect(() => {
        const filteredEvents = workEvents.filter((workEvent) => {
            return moment(workEvent.date).format('YYYYMMDD') === moment(selectedDate).format('YYYYMMDD')
        })

        const editingTimePeriods = TimePeriods
            .map((tp) => {
                tp.checked = false
                tp.markedPriceDollar = defaultPrice
                tp.workTime = defaultWorkTime
                tp.breakTime = defaultBreakTime
                return tp
            })
            .map((tp) => {
                const matchedEvents = filteredEvents.filter((ev) => {
                    return (ev.fk_time_period_id === tp.id)
                })
                if (matchedEvents && matchedEvents.length > 0) {
                    // morning
                    if (tp.id === 7) {
                        const indexOfTimePeriodId11 = findTimerPeriodIndexById({timePeriodId: 11})
                        const indexOfTimePeriodId12 = findTimerPeriodIndexById({timePeriodId: 12})
                        const indexOfTimePeriodId13 = findTimerPeriodIndexById({timePeriodId: 13})
                        const updatingIndices = [indexOfTimePeriodId11, indexOfTimePeriodId12, indexOfTimePeriodId13]
                        updatingIndices.map((ind) => {
                            TimePeriods[ind].checked = true
                            TimePeriods[ind].markedPriceDollar = matchedEvents[0].marked_price_cent / 100 || defaultPrice
                            TimePeriods[ind].workTime = matchedEvents[0].work_time || defaultWorkTime
                            TimePeriods[ind].breakTime = matchedEvents[0].break_time || defaultBreakTime
                        })
                    } else if (tp.id === 8) {
                        const indexOfTimePeriodId16 = findTimerPeriodIndexById({timePeriodId: 16})
                        const indexOfTimePeriodId17 = findTimerPeriodIndexById({timePeriodId: 17})
                        const indexOfTimePeriodId18 = findTimerPeriodIndexById({timePeriodId: 18})
                        const updatingIndices = [indexOfTimePeriodId16, indexOfTimePeriodId17, indexOfTimePeriodId18]
                        updatingIndices.map((ind) => {
                            console.log(ind)
                            TimePeriods[ind].checked = true
                            TimePeriods[ind].markedPriceDollar = matchedEvents[0].marked_price_cent / 100 || defaultPrice
                            TimePeriods[ind].workTime = matchedEvents[0].work_time || defaultWorkTime
                            TimePeriods[ind].breakTime = matchedEvents[0].break_time || defaultBreakTime
                        })
                    } else if (tp.id === 9) {
                        const indexOfTimePeriodId21 = findTimerPeriodIndexById({timePeriodId: 21})
                        const indexOfTimePeriodId22 = findTimerPeriodIndexById({timePeriodId: 22})
                        const updatingIndices = [indexOfTimePeriodId21, indexOfTimePeriodId22]
                        updatingIndices.map((ind) => {
                            TimePeriods[ind].checked = true
                            TimePeriods[ind].markedPriceDollar = matchedEvents[0].marked_price_cent / 100 || defaultPrice
                            TimePeriods[ind].workTime = matchedEvents[0].work_time || defaultWorkTime
                            TimePeriods[ind].breakTime = matchedEvents[0].break_time || defaultBreakTime
                        })
                    } else {
                        tp.checked = true
                        tp.markedPriceDollar = matchedEvents[0].marked_price_cent / 100 || defaultPrice
                        tp.workTime = matchedEvents[0].work_time || defaultWorkTime
                        tp.breakTime = matchedEvents[0].break_time || defaultBreakTime
                    }
                }
                return tp
            })
        setTimePeriods(editingTimePeriods)
    }, [selectedDate])

    return <Card className="w-full mb-16">
        <Grid container className="w-full">
            <Grid item xs={3} className="px-8">
                <Grid container spacing={8} className="flex-col">
                    <Grid item>
                        <TextField
                            label="價格(USD)"
                            value={defaultPrice}
                            margin="normal"
                            variant="filled"
                            type="number"
                            onChange={e => {
                                const price = Math.max(0, e.target.value)
                                setDefaultPrice(price.toString().replace(/^0+/, '') || 0)
                            }}/>
                    </Grid>
                    <Grid item>
                        <TextField
                            pattern="[0-9]*"
                            label="看診時間(分鐘)"
                            value={defaultWorkTime}
                            margin="normal"
                            variant="filled"
                            type="number"
                            onChange={e => {
                                   // Fix the input price between [1, 60] and remove '.'
                                   const price = Math.max(1, Math.min(60, e.target.value.replace(/\D/,'')))
                                   // Remove all leading '0's Example: '0001' -> '1'
                                   setDefaultWorkTime(price.toString().replace(/^0+/, '') || 0)
                            }}/>
                    </Grid>
                    <Grid item>
                        <TextField
                            label="診間休息(分鐘)"
                            value={defaultBreakTime}
                            margin="normal"
                            variant="filled"
                            type="number"
                            onChange={e => {
                                // Fix the input price between [0, 59] and remove '.'
                                const price = Math.max(0, Math.min(59, e.target.value.replace(/\D/,'')))
                                setDefaultBreakTime(price.toString().replace(/^0+/, '') || 0)
                            }}/>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={9}>
                <div style={{ height: 700 }}>
                    <BigCalendar
                        className="flex flex-1"
                        selectable
                        localizer={localizer}
                        resizable
                        defaultDate={new Date()}
                        events={workEvents.map((workEvent) => {
                            return {
                                title: workEvent.time_period.label,
                                start: moment(workEvent.date).startOf('date').toDate(),
                                end: moment(workEvent.date).endOf('date').toDate()
                            }
                        })}
                        defaultView={BigCalendar.Views.MONTH}
                        startAccessor="start"
                        endAccessor="end"
                        views={['month']}
                        timeslots={1}
                        showMultiDayTimes
                        components={{
                            toolbar: agendaToolbar,
                            month: {header: monthCustomHeader},
                        }}
                        onSelectSlot={ slotInfo => {
                            setOpenModal(true)
                            setSelectedDate(slotInfo.start)
                        }}
                        onNavigate={(date, view, action) => {
                            let newDate = moment(date)
                            onDateUpdate(newDate)
                        }}
                    />
                </div>

                {/* Work event List */}
                <Paper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>日期</TableCell>
                                <TableCell>時段</TableCell>
                                <TableCell>價格(US$)</TableCell>
                                <TableCell>看診時間(分鐘)</TableCell>
                                <TableCell>診間休息(分鐘)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {workEvents && workEvents
                                .sort((a, b) => {
                                    if (moment(a.date).isBefore(moment(b.date))){
                                        return -1
                                    }else if(moment(a.date).isAfter(moment(b.date))){
                                        return 1
                                    }else{
                                        return (a.time_period.start_time_int - b.time_period.start_time_int)
                                    }
                                })
                                .map((workEvent, index) =>
                                    <TableRow key={index}>
                                        <TableCell>
                                            {moment(workEvent.date).format("YYYY/MM/DD")}
                                        </TableCell>
                                        <TableCell>
                                            {workEvent.time_period.start_time} - {workEvent.time_period.end_time}
                                        </TableCell>
                                        <TableCell>
                                            <AgendaPrice
                                                price={{min: workEvent.marked_price_cent, max: workEvent.marked_price_cent}}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            {workEvent.work_time}
                                        </TableCell>
                                        <TableCell>
                                            {workEvent.break_time}
                                        </TableCell>
                                    </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Paper>

                {/* Popup Dialog*/}
                <EditTimePeriodDialog
                    selectedDate={selectedDate}
                    handleClose={() => handleClose()}
                    openModal={openModal}
                    timePeriods={timePeriods}
                    setTimePeriods={setTimePeriods}
                    onSaveButtonClick={onSaveButtonClick}
                    workEvents={workEvents}
                />
            </Grid>
        </Grid>
    </Card>
}

const mapDispatchToProps = dispatch => bindActionCreators({
    ...ReduxGlobal.ActionCreator,
}, dispatch)

export default (withRouter(connect(null, mapDispatchToProps)(AgendaTable)))



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/institutionMedical/tabs/agenda/AgendaTable.js